export default __webpack_public_path__ + "static/media/Sesame_Info.9dc0319d.jpg";